<template>
  <div class="header">
    <i class="nav-menu dib" @click="onClick">
    </i>
  </div>
</template>
<script>
export default {
  name: 'pageHeader',
  data () {
    return {
      // pageName: '',
      navList: [
        {
          path: 'home',
          name: '首页'
        },
        {
          path: 'product',
          name: '产品介绍'
        },
        {
          path: 'cooperation',
          name: '合作案例'
        },
        {
          path: 'about',
          name: '关于我们'
        }
      ],
      logoUrl: 'https://cookhere-images.oss-cn-shenzhen.aliyuncs.com/202105/logo.png'
    }
  },
  computed: {
    pageName ({ $route: { name } }) {
      return name
    }
  },
  methods: {
    onClick () {
      this.$emit('onClick')
    }
  }
}
</script>
<style lang="scss" scoped>
.header {
  position: fixed;
  left: 0;
  right: 0;
  top:0;
  height: 2rem;
  line-height: 2rem;
  background: #000 url("../assets/logo.png") ;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 4.267rem 1.067rem;
  .nav-menu {
    margin-left: .267rem;
    display: inline-block;
    height: 1.333rem;
    width: 1.333rem;
    vertical-align: middle;
    background-image: url("data:image/svg+xml,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='64' height='64'%3E%3Cpath d='M128 213.333h768q17.664 0 30.165 12.502T938.667 256t-12.502 30.165T896 298.667H128q-17.664 0-30.165-12.502T85.333 256t12.502-30.165T128 213.333zm0 512h768q17.664 0 30.165 12.502T938.667 768t-12.502 30.165T896 810.667H128q-17.664 0-30.165-12.502T85.333 768t12.502-30.165T128 725.333zm0-256h768q17.664 0 30.165 12.502T938.667 512t-12.502 30.165T896 554.667H128q-17.664 0-30.165-12.502T85.333 512t12.502-30.165T128 469.333z' fill='%23fff'/%3E%3C/svg%3E");
    background-size: cover;
    background-repeat: no-repeat;
  }
  .nav-list {
    padding-top: .773rem;
    .item {
      display: inline-block;
      line-height: .427rem;
      margin-right: 1.067rem;
      padding-bottom: .267rem;
      font-size: .267rem;
      color: rgba(255, 255, 255, 0.7);
      cursor: pointer;
      &.is-active {
        color: #cf4d4d;
        //border-bottom: 2px solid;
    }
  }
  }
}
</style>
